import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import FormText from '../../Fields/FormText.js';
import { getQuestions, postQuestion } from '../../Api/UserActions.js'
import { getJsonItem , isEmpty} from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js';


declare var globalSns;

class Questions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            questions: null,
            validationErrors: [],
            showValidation: false,

        }

        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleValueBlur = this.handleValueBlur.bind(this);
        this.validateText = this.validateText.bind(this);
        
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getQuestions(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                questions: data     
            });  
        });
        
    }

    saveData(data) {
        postQuestion(this, data.seqJob, data.seqQuest, data.answer);
    }

    validateText(index) {
        var questions = this.state.questions;
        var answer = questions[index].answer;
        if(isEmpty(answer)){
            return getTranslation("basicform.erroremptyvalue")
        }
        return "";
    }
    
    isValidated() {
        if(isEmpty(this.state.questions)){
            return true;
        }
        this.setState({
            showValidation:true        })
        for (let q of this.state.questions) {
            if(q.mandatory && isEmpty(q.answer)){
                return false;
            }
        }
        return true;
    }

    handleValueChange(e) {
        var key = parseInt(e.target.id.toString().replace("question", ""), 10);
        var item = getJsonItem(this.state.questions, "seqQuest", key);
        var index = this.state.questions.indexOf(item);

        this.setState({
            questions: update(this.state.questions, {[index]: {answer: {$set: e.target.value}}})
        }); 
        
    }

    handleValueBlur(e) {
        var key = parseInt(e.target.id.toString().replace("question", ""), 10);
        var item = getJsonItem(this.state.questions, "seqQuest", key);

        this.saveData(item);
    }

     

    render() {
        
        return (
            <div>
                {
                    (this.state.questions == null) ? 
                        <Loading/> : 
                        <div>
                            {
                                (this.props.showTitle && this.state.questions.length > 0) ? 
                                    <h4 className="legend-title">{getTranslation("sns.webparts.motivation.motivation")}</h4> : ""
                            }
                            {
                                this.state.questions.map((question,index) =>

                               <FormText 
                                    key={question.seqQuest} 
                                    id={"question" + question.seqQuest} 
                                    rows={question.length} 
                                    className="full-width"
                                    text={question.quest}  
                                    value={question.answer} 
                                    required={question.mandatory}
                                    onChange={this.handleValueChange} 
                                    onBlur={this.handleValueBlur} 
                                    showValidation={this.state.showValidation}
                                    validationText={question.mandatory && this.validateText(index) }     
                                     />
                                    
                                 
                                )
                            }
                        </div>
                }
            </div>
        );
    }
}

export default Questions;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Questions.js